import { render, staticRenderFns } from "./MyInjectionMachineDetails.vue?vue&type=template&id=6a2377dc&"
import script from "./MyInjectionMachineDetails.vue?vue&type=script&lang=js&"
export * from "./MyInjectionMachineDetails.vue?vue&type=script&lang=js&"
import style0 from "./MyInjectionMachineDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports